import { faSquare } from '@fortawesome/pro-regular-svg-icons';
import { faSquareCheck } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { cn, formatNumberWithDots } from '~/helpers/utils';
import { MortgageType, MortgageTypeLabels } from '~/types/Calculations';
import type { ProviderMatch } from '~/types/Provider';

type ProviderMatchItemProps = ProviderMatch & {
  selectedSlug?: string;
  onHandleSelect: (match: string) => void;
  isBestDeal: boolean;
};

export const getMortgageTypeLabel = (type: MortgageType) => {
  return MortgageTypeLabels[type];
};

const ProviderMatchItem: React.FC<ProviderMatchItemProps> = ({
  slug,
  name,
  logoUrl,
  mortgage,
  isBestDeal,
  selectedSlug,
  onHandleSelect,
}) => {
  const isSelected = selectedSlug === slug;
  return (
    <button
      type="button"
      onClick={() => onHandleSelect(slug)}
      className={cn(
        'relative flex w-full items-center justify-between gap-4 px-4 py-5',
        'rounded-lg border-2 bg-white text-sm text-blue-800 no-underline',
        isSelected ? 'border-blue-500' : 'border-stone-100'
      )}
      title={name}
      key={slug}
    >
      {isBestDeal && (
        <div className="absolute left-1/2 top-0 inline-block -translate-x-1/2 -translate-y-1/2 text-sm font-bold text-white">
          <span className="mr-1 rounded-lg bg-blue-500 px-3 py-1">
            Beste deal
          </span>
        </div>
      )}
      <FontAwesomeIcon
        icon={isSelected ? faSquareCheck : faSquare}
        className={cn(
          'text-2xl',
          isSelected ? 'text-blue-500' : 'text-stone-300'
        )}
      />
      <div>
        <div className="relative h-12 w-20">
          <img
            className="absolute inset-0 h-full w-full object-contain"
            src={logoUrl}
            alt={name}
          />
        </div>
      </div>
      <div className="grid w-full grid-cols-2 pl-4">
        <div>
          <span className="block font-display font-bold text-black">
            Maandlasten
          </span>
          <span>
            &euro; {formatNumberWithDots(mortgage.grossMonthlyCosts, 2, 2)}
          </span>
        </div>
        <div>
          <span className="block font-display font-bold text-black">Rente</span>
          <span>{mortgage.rate} %</span>
        </div>
      </div>
    </button>
  );
};

export default ProviderMatchItem;
